import { useSelector } from "react-redux";
import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";
import { deleteStockOutput, requestDeletingOutput, selectState } from "../outputSlice";
import { FormatDateShort } from "utils/dateUtils";

const DeleteOutputModal = () => {
  const { outputToDelete } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(requestDeletingOutput(undefined));
  };

  const doDelete = async () => {
    try {
      if (outputToDelete !== undefined) {
        await dispatch(deleteStockOutput(outputToDelete.outputId));
        toast.success("Uspesno obrisan.");
        close();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={outputToDelete !== undefined}
      title="Brisanje izlaza"
    >
      <p className="info-msg">
        {outputToDelete && `Da li ste sigurni da želite da obrišete izlaz i sve povraćaje od njega (magacin: ${outputToDelete.repository.name}, br otpremnice: ${outputToDelete.billOfLandingId}, datum: ${FormatDateShort(outputToDelete.date)})?`}
      </p>
    </Modal>
  );
};

export default DeleteOutputModal;
